import { DateTimeHelper } from '../../../../helpers/date-time.helper';
import { StopPointHelper } from '../../../../helpers/stop-point.helper';
import type { ICall } from '../../../../models/call.model';
import { ILinkEndpoint } from '../../../../models/link-endpoint.model';
import { LocationType } from '../../../../models/location-type.enum';
import type { INote } from '../../../../models/note.model';
import { StopPointApiModel } from './stop-point.api-model';

export class CallApiModel {
  public static mapToBusinessModel(apiModel: CallApiModel): ICall {
    return {
      plannedTime: DateTimeHelper.parse(apiModel.plannedTime),
      estimatedTime: apiModel.estimatedTime ? DateTimeHelper.parse(apiModel.estimatedTime) : undefined,
      notes: apiModel.notes,
      stopPoint: StopPointApiModel.mapToBusinessModel(apiModel.stopPoint),
      realtimeStopPoint: apiModel.realtimeStopPoint ? StopPointApiModel.mapToBusinessModel(apiModel.realtimeStopPoint) : undefined,
    };
  }

  public static mapToLinkEndpointBusinessModel(apiModel: CallApiModel): ILinkEndpoint {
    return {
      gid: apiModel.stopPoint.gid,
      name: apiModel.stopPoint.name,
      locationType: LocationType.stopPoint,
      latitude: apiModel.stopPoint.latitude,
      longitude: apiModel.stopPoint.longitude,
      plannedTime: DateTimeHelper.parse(apiModel.plannedTime),
      estimatedTime: apiModel.estimatedTime ? DateTimeHelper.parse(apiModel.estimatedTime) : undefined,
      notes: apiModel.notes ?? [],
      platform: apiModel.stopPoint.platform,
      stopPointType: StopPointHelper.mapToStopPointType(apiModel.stopPoint.stopPointType),
    };
  }

  public plannedTime!: string;
  public estimatedTime?: string;
  public notes?: INote[];
  public stopPoint!: StopPointApiModel;
  public estimatedOtherwisePlannedTime?: string;
  public realtimeStopPoint?: StopPointApiModel;
}
